import React from 'react'
import { Flex, FlexProps } from 'rebass/styled-components'

import { Breadcrumbs, type BreadcrumbItem } from './Breadcrumbs'
import { Actions } from './Actions'
import { SearchField } from './SearchField'
import MetadataList from '../MetadataList'

import styles from './BoxHeader.module.css'

export interface BoxHeaderProps extends FlexProps {
  actionItems?: React.ReactNode[]
  breadcrumbItems: BreadcrumbItem[]
  metaItems?: string[] | React.ReactNode[]
  searchField?: {
    placeholder: string
    onChange: (value: string) => void
  }
}

export const BoxHeader = ({
  actionItems,
  breadcrumbItems,
  metaItems,
  searchField,
  sx,
  ...props
}: BoxHeaderProps): JSX.Element => {
  return (
    <Flex
      data-name="BoxHeader"
      className={styles.boxHeader}
      sx={{
        ...sx
      }}
      {...props}
    >
      <Breadcrumbs items={breadcrumbItems} />
      {searchField ? <SearchField placeholder={searchField.placeholder} onChange={searchField.onChange} /> : null}
      {actionItems && actionItems.length > 0 ? <Actions items={actionItems} /> : null}
      {metaItems && metaItems.length > 0 ? <MetadataList items={metaItems} /> : null}
    </Flex>
  )
}
